import Swiper, { Navigation } from 'swiper'

window.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.reviews__slider .reviews__swiper', {
        direction: 'horizontal',
        init: false,
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper__btn-next',
            prevEl: '.swiper__btn-prev',
            enabled: true,
            hiddenClass: '.swiper__btn-hidden',
        },
    })

    const setPagination = ({ realIndex, slides, ...rest }) => {
        const pagination = document.querySelector('.reviews__slider .swiper__pagination')
        pagination.innerHTML = `0${realIndex + 1}/0${slides.length}`
    }

    swiper.on('slideChange', setPagination)
    swiper.on('init', setPagination)

    swiper.init()
})
